import { FightEvents, FightTurn } from '../../components/interfaces/Interfaces';
import { ASSET_CONFIG } from '../../util/assetConfig';

type Translate = (key: string, options: { defaultValue: string }) => string;
export function battleCaption(turn: FightTurn, t: Translate) {
  const basic = !turn.skillId || turn.skillId === 1;
  const skill = turn.skillId ? t(`skill__${turn.skillId}--name`, { defaultValue: `สกิล ${turn.skillId}` }) : '';
  switch (turn.event) {
    case FightEvents.BEGIN_ATTACK: return 'เตรียมโจมตี';
    case FightEvents.CANT_MOVE: return 'ไม่สามารถเคลื่อนไหวได้';
    case FightEvents.USER_SKILL:
    case FightEvents.CHANGE_BUFF:
      if (turn.event === FightEvents.CHANGE_BUFF && !turn.skillId) return null;
      return `${basic ? 'โจมตี' : `ใช้ ${skill}`}${turn.isHit === false ? ' พลาด! เป้าหมายหลบได้' : turn.isHit === true ? ` สำเร็จ!${turn.isCrit ? ' คริติคอล!' : ''}` : ''}${turn.targetLastDamage ? ` ความเสียหาย ${Math.abs(turn.targetLastDamage)}` : ''}${turn.incHp ? ` ฟื้นฟู HP ${turn.incHp}` : ''}`;
    case FightEvents.PRIORITY_MUL: return 'ชิงจังหวะโจมตี';
    case FightEvents.COUNTER_DAMAGE: return 'สวนกลับ';
    case FightEvents.BACK_THROWED: return 'ขว้างระเบิดกลับ';
    case FightEvents.BE_DIE: return 'หมดสภาพการต่อสู้';
    case FightEvents.CHANGE_ROLE: return 'เปลี่ยนตัวละคร';
    case FightEvents.VICTORY: return 'ชนะการต่อสู้!';
    default: return null;
  }
}

export function battleActorName(role: any, t: Translate, partyNames: Record<number, { displayName: string }> = {}) {
  if (role?.displayName) return role.displayName;
  if (role?.isOnOffense !== false && partyNames[role?.id]?.displayName) return partyNames[role.id].displayName;
  if (typeof role?.id === 'string' && !/^\d+$/.test(role.id)) {
    return t(role.id, { defaultValue: role.id });
  }
  if (role?.name) return t(role.name, { defaultValue: role.name });
  // Monster IDs and sprite/avatar IDs are different: try the actual monster first.
  for (const id of [role?.id, role?.avatar]) {
    if (id == null) continue;
    const name = t(`monster__${id}--name`, { defaultValue: '' });
    if (name) return name;
  }
  // Arena NPCs use outfit sprites, so resolve their character name from the outfit catalog.
  const outfit = Object.entries(ASSET_CONFIG.ITEMS ?? {}).find(([, data]) => (data as any)?.[0] === `avatars/${role?.avatar}`);
  if (outfit) {
    const name = ASSET_CONFIG.ITEM_NAMES?.[outfit[0]] || t(`item__${outfit[0]}--name`, { defaultValue: '' });
    if (name) return name;
  }
  return `ตัวละคร ${role?.avatar ?? role?.id ?? ''}`.trim();
}
